module.exports = __webpack_public_path__ + "media/images/avatar-3-4638b6c993881147e747d7396cac2924.png";